// extracted by mini-css-extract-plugin
var _1 = "MessageText-moduleMessageText__SpMgH";
export { _1 as "MessageText" }
